export const TIPO_DATOS_FISCALES = {
  EMPRESA: 'EMPRESA',
  AUTONOMO: 'AUTONOMO',
  PARTICULAR: 'PARTICULAR',
};
